// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__31xQr","validationTips":"StatementDescriptor_validationTips__QJkLi"};